import React, { FC, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { DEFAULT_DESCRIPTION_CHAR_LIMIT } from '../utils/DataConstants';

const OWRichTextEditor: FC<any> = ({
	initialEditorState,
	editorRef,
	className,
}): React.ReactElement => {
	const [charCount, setCharCount] = useState(0);
	const [error, setError] = useState('');
	const updateCharCount = (editor) => {
		const content = editor.getContent();
		setCharCount(content.length);

		if (content.length > DEFAULT_DESCRIPTION_CHAR_LIMIT) {
			setError(`Content exceeds the ${DEFAULT_DESCRIPTION_CHAR_LIMIT} character limit!`);
		} else {
			setError('');
		}
	};

	return (
		<div className={className}>
			<Editor
				tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
				onInit={(evt, editor) => (editorRef.current = editor)}
				initialValue={initialEditorState}
				init={{
					height: 240,
					menubar: false,
					plugins: [
						'autolink',
						'lists',
						'link',
						'image',
						'charmap',
						'preview',
						'anchor',
						'visualblocks',
						'code',
						'insertdatetime',
						'media',
						'table',
						'code',
					],
					toolbar:
						'undo redo | formatselect | bold italic underline | table | bullist numlist | ' +
						'removeformat',
					content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
					setup: (editor) => {
						editor.on('init', () => {
							updateCharCount(editor);
						});
					},
				}}
				onEditorChange={(content, editor) => updateCharCount(editor)}
			/>
			<div className="pt-1 text-gray-500">
				{charCount}/{DEFAULT_DESCRIPTION_CHAR_LIMIT}
				{error && <div style={{ color: 'red' }}>{error}</div>}
			</div>
		</div>
	);
};

export default OWRichTextEditor;
